// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3Y1rv","title":"Header_title__2z0w0","left":"Header_left__1EGeB","clinicName":"Header_clinicName__16ljV"};